import { IInitialState } from '../types/initialState.types';

// Todo: Need handle global state for loader
const initialState: IInitialState = {
  auth: {
    userIdentityData: null,
  },
  recruiter: null,
  modules: null,
  company: null,
  teamMembersStats: null,
  quotas: null,
  interviewLibrary: {
    problems: [],
    meta: null,
  },
  hiringRoles: {
    meta: {
      count: 0,
      next: null,
      previous: null,
    },
    results: [],
  },
  campaigns: null,
  campaign: {
    campaignData: null,
    loading: false,
    error: null,
  },
  campaignSummary: null,
  cocallerAppSettings: null,
  jobRoles: {
    meta: null,
    aggregates: null,
    results: [],
  },
  candidates: {
    meta: null,
    aggregates: null,
    results: [],
  },
  breadcrumbs: [],
  modal: {
    confirmModal: null,
  },
  interviewers: {
    meta: {},
    objects: [],
  },
  aiInterview: {
    meta: {
      total_count: 0,
      total_pages: 0,
      next: null,
      page_number: 0,
      offset: 0,
      limit: 0,
      previous: null,
      type: '',
    },
    interviewList: [],
    bulkInviteInProgress: false,
    bulkInviteStatusPolling: false,
    bulkInviteStatusData: null,
    bulkTestSlug: null,
    getTryTestInProgress: false,
  },
  manageInterviewersModal: {
    show: false,
  },
  loader: {
    show: false,
    message: null,
  },
  alert: {
    show: false,
    message: null,
    type: '',
    hideInSeconds: undefined,
    version: '',
  },
  toast: {
    id: '',
    message: '',
    variant: undefined,
    duration: 0,
    onClose: () => {},
  },
  technologies: {
    DBA: [],
    SCR: [],
  },
  roles: {
    roles: [],
    loading: true,
    error: null,
  },
  backoffice: {
    teamMembersStats: null,
    monthlyStats: null,
    quotas: null,
    selectedCompany: null,
    loading: false,
    error: null,
    isLazyLoadingInProgress: false,
    ledgerDetails: null,
    leadgerLoading: false,
    ledgerDetailsError: null,
  },
  ledgerDetails: {
    ledgerDetails: null,
    leadgerLoading: false,
    ledgerDetailsError: null,
  },
};

export default initialState;
